import validateHelpers from 'utils/validations';

export default {
  email: [
    validateHelpers.required(),
    validateHelpers.email(),
  ],
  password: validateHelpers.required(),
};
